var curCont = 0;
var trigger = false;
var content = [];
var lazy = [];

export default function infinate_scroll(){

    const scrollContent = document.querySelector('.project-grid');
    var prompts = [];


    if(scrollContent){

        const scroller = document.querySelector('.scroller');

        var projects = scrollContent.querySelectorAll('.project');
        content = Array.from(projects);

        var totalWidth = Object.values(scrollContent.children).reduce((total, i) => total + i.offsetWidth, 0);
        while (totalWidth < window.innerWidth) {
            totalWidth = Object.values(scrollContent.children).reduce((total, i) => total + i.offsetWidth, 0);
            add_clone(scrollContent);
        }
      
        var scrollPos = 0;
        var conainerWidth = scrollContent.offsetWidth;
        

        curCont = 0;
        trigger = false;

        var scrollDir = true;
        var jump = true;

        lazy = scrollContent.querySelectorAll('.lazy');

        for (let a = 0; a < lazy.length; a++) {
            const element = lazy[a];
            load_asset(element, 0);
        }

     

        for (let a = 0; a < projects.length; a++) {
            
            const project = projects[a];

            project.addEventListener('mouseover', function(e){
                e.preventDefault();

                let minis = project.querySelectorAll('.mini-lazy');
                for (let b = 0; b < minis.length; b++) {

                    const asset = minis[b];
                    asset.src = asset.dataset.src;
                    asset.classList.remove('mini-lazy');
                }

            });

            bind_link(project);
            
          
        }



        let isDown = false;
        let startX;
        let scrollLeft;
        let mousemoveCoutn = 0;

        scroller.addEventListener('mousedown', (e) => {

            const hasClassInPath = e.composedPath().some(element => {
                return element.classList && element.classList.contains('c-wrap');
            }); 

            mousemoveCoutn = 0;

            if(!hasClassInPath){
                isDown = true;
                startX = e.pageX - scroller.offsetLeft;
                scrollLeft = scroller.scrollLeft;
                scroller.style.cursor = 'grabbing'; 
            }
        });

        scroller.addEventListener('mouseleave', () => {
            isDown = false;
            scroller.style.cursor = 'unset'; 
            scroller.classList.remove('dragging');
        });

        scroller.addEventListener('mouseup', () => {
            isDown = false;
            scroller.style.cursor = 'unset'; 
            scroller.classList.remove('dragging');
        });

        scroller.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            console.log(mousemoveCoutn);

            e.preventDefault();
            scroller.classList.add('dragging');
            const x = e.pageX - scroller.offsetLeft;
            const walk = (x - startX) * 2; 

            scroller.scrollTo({
                left: scrollLeft - walk,
                behavior: 'instant'
            });
            
        });


        scroller.addEventListener('scroll', function(e){

            var newPos = scroller.scrollLeft;

            if(window.innerWidth <= 659){
                newPos = scroller.scrollTop;
            }


            if(scrollPos < newPos){
                scrollDir = true;
            }else{
                scrollDir = false;
            }


            scrollPos = newPos;
    
            conainerWidth = scrollContent.scrollWidth;
            var scrollLeft = (conainerWidth - window.innerWidth) - scrollPos;

  
            if(window.innerWidth <= 659){
                conainerWidth = scrollContent.offsetHeight;
                scrollLeft = (conainerWidth - window.innerHeight) - scrollPos;
            }

            if(scrollLeft < 100 ){
                
                add_clone(scrollContent);

            }

            if(trigger && jump){

                let bound = trigger.getBoundingClientRect();
                let x = bound.x;

                if(scrollDir){

                    if(x < 0){
                        let fistBound = content[1].getBoundingClientRect();
                        let scrollTo = fistBound.left + scrollPos; 

                        if(window.innerWidth <= 659){
                            scrollTo = fistBound.top + scrollPos; 
                        }
                        
                        jump = false;


                        if(window.innerWidth <= 659){
                            scroller.scrollTo({
                                top: scrollTo,
                                behavior: 'instant'
                            });
                        }else{
                            scroller.scrollTo({
                                left: scrollTo,
                                behavior: 'instant'
                            });
                        }
                    }

                }else{

                    var first = content[0].getBoundingClientRect();
                    var last  =  content[content.length-1].getBoundingClientRect();

                    if(scrollPos < first.width){
                        
                        let scrollTo = last.left + scrollPos + window.innerWidth; 
                        if(window.innerWidth <= 659){
                            scrollTo = last.top  + scrollPos + window.innerHeight; 
                        }

                        jump = false;


                        if(scroller.innerWidth <= 659){
                            scroller.scrollTo({
                                top: scrollTo,
                                behavior: 'instant'
                            });
                        }else{
                            scroller.scrollTo({
                                left: scrollTo,
                                behavior: 'instant'
                            });
                        }

                        

                    }
                    
                    
                }


            }else{
                jump = true;
            }

        });
        
    };


    


  window.addEventListener('resize', function(){
    
    if(prompts.length){
        for (let a = 0; a < prompts.length; a++) {
            const element = prompts[a];
            const text = element.querySelector('.text');
            if(text){
                text.parentNode.style.removeProperty("height");
                var rec = text.getBoundingClientRect();
                var newH = roundUpToMultiple(rec.height, 12);
                var testH = 0;

                var n = 0;

                while(newH !== testH && n < 10){

                    n++;

                    rec = text.getBoundingClientRect();
                    testH = roundUpToMultiple(rec.height, 12);
                   
                    text.parentNode.style.height = testH + 'px';
                    
                    rec = text.getBoundingClientRect();
                    newH = roundUpToMultiple(rec.height, 12);

                }

            }
            
        }
    }

  });

};



function typeOut(element, text, speed, delay) {

    let index = 0;
    
    element.style.opacity = 1;
    const words = text.split(' ');

    function type() {

        if (index < words.length-1) {
            element.textContent += words[index] + ' ';
            index++;
            index++;
    
            setTimeout(type, speed);
  
        }else{
            element.textContent = text;

           
        }
    
        // const newH = roundUpToMultiple(element.getBoundingClientRect().height, 12);
        // element.parentNode.style.height = newH + 12 + 'px';
    
    }
  
    setTimeout(function(){
      type();
    }, delay);

  }


  function start_touch(elm){
    let minis = elm.querySelectorAll('.mini-lazy');
    for (let b = 0; b < minis.length; b++) {
        const asset = minis[b];
        asset.src = asset.dataset.src;
        asset.classList.remove('mini-lazy');
    }

    elm.classList.add('hovering');

  }

function stop_touch(elm){
    elm.classList.remove('hovering');
}


function add_clone(scrollContent){

    var toClone = scrollContent.querySelectorAll('.og');
    let clone = toClone[curCont].cloneNode(true);

    clone.classList.remove('og');
    clone.classList.add('clone');

    if(clone.querySelector('.video-embed')){

        let embed = clone.querySelector('.video-embed');
        let embedWrap = clone.querySelector('.embed-wrap');
        embed.innerHTML = '';
        embed.dataset.vimeoInitialized = false;
        embed.removeAttribute('data-vimeo-initialized');
        embedWrap.classList.remove('embed-loaded');
        embedWrap.classList.remove('playing');
        embedWrap.classList.add('muted');
        embed.classList.remove('bound');

    }

    let links = clone.querySelectorAll('.bound');
    
    if(links){
        for (let a = 0; a < links.length; a++) {
            const element = links[a];
            element.classList.remove('bound');
            
        }
    }

    if(!trigger && curCont == 1){
        trigger = clone;
    }

    scrollContent.appendChild(clone);

        var lazy = clone.querySelectorAll('.lazy');

        for (let a = 0; a < lazy.length; a++) {
            const element = lazy[a];
            load_asset(element, 0);
        }


    if(clone.querySelector('.mini-lazy')){

        clone.addEventListener('mouseover', function(e){
            e.preventDefault();
           
            let minis = clone.querySelectorAll('.mini-lazy');
            for (let b = 0; b < minis.length; b++) {

                const asset = minis[b];
                asset.src = asset.dataset.src;
                asset.classList.remove('mini-lazy');
            }

        });
    }

    bind_link(clone);

    curCont++;

    if(curCont >= content.length){
        curCont = 0;
    }

};

function load_asset(asset, i){

    let url =  asset.dataset.src;
    let project = asset.closest('.project');

    asset.onload = function() {
        asset.classList.remove('lazy');
        project.classList.add('loaded');
    }

    asset.src = url;

    if(i < lazy.length - 1){
        i++;
        setTimeout(function(){
            load_asset(lazy[i], i);
        }, 10);
    }

};

function bind_link(elm){

    if(window.touch){

        var firstAsset = elm.querySelector('.first-asset');

        var link = firstAsset.querySelector('a');

   
        if(link){
        
            link.addEventListener('click', function(e){
                
                e.preventDefault();
                e.stopPropagation();


                if(elm.classList.contains('hovering')){
                    stop_touch(elm);
                }else{
                    start_touch(elm);
                }

            });

        }else{

            elm.addEventListener('click', function(e){
                
                e.preventDefault();
                e.stopPropagation();


                if(elm.classList.contains('hovering')){
                    stop_touch(elm);
                }else{
                    start_touch(elm);
                }

            });
            

        }
    }

};


function roundUpToMultiple(number, multiple) {
    return (Math.round(number / multiple) + 2 ) * multiple;
}
